import { useEffect, useState } from 'react';
import API from '../../api';

export default function ManageFacultes() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    API.get('facultes/').then((r) => setItems(r.data.results || r.data));
  }, []);

  return (
    <div>
      <div className="page-header">
        <h2><i className="bi bi-bank" /> Facultés</h2>
        <span className="badge-status badge-info">{items.length} facultés (source : fichier référentiel)</span>
      </div>

      <div className="data-table-wrapper">
        <table className="data-table">
          <thead><tr><th>#</th><th>Nom</th></tr></thead>
          <tbody>
            {items.length === 0 ? (
              <tr><td colSpan="2"><div className="empty-state"><i className="bi bi-bank" /><p>Aucune faculté</p></div></td></tr>
            ) : items.map((f, i) => (
              <tr key={f.id}>
                <td>{i + 1}</td>
                <td>{f.nom}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
